import { render } from "./WalletReport.vue?vue&type=template&id=0c92596e&scoped=true"
import script from "./WalletReport.vue?vue&type=script&lang=js"
export * from "./WalletReport.vue?vue&type=script&lang=js"

import "./WalletReport.vue?vue&type=style&index=0&id=0c92596e&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c92596e"]])

export default __exports__